import script from "./SpeV2MonitorApproval.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeV2MonitorApproval.vue?vue&type=script&setup=true&lang=js"

import "./SpeV2MonitorApproval.vue?vue&type=style&index=0&id=87ace0f0&scoped=true&lang=css"
import "./SpeV2MonitorApproval.vue?vue&type=style&index=1&id=87ace0f0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87ace0f0"]])

export default __exports__